import { createAction, props } from '@ngrx/store';
import { IUser } from '../models/IUser';

export const loadUser = createAction(
  '[User] load the current logged in User'
);

export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ userData: IUser }>()
);

export const loadUserError = createAction(
  '[User] Load User Error',
  props<{ error: any }>()
);
